import React from "react";
import { ServerErrorPage } from "../pages/ServerErrorPage";

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: any;
}

export class ErrorBoundary extends React.Component<
  React.PropsWithChildren<{}>,
  State
> {
  constructor(props: {}) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  override componentDidCatch(error: Error, errorInfo: any) {
    this.setState({ errorInfo });

    // Attempt to report to Sentry if available and configured
    try {
      if ((globalThis as any).__SENTRY_DSN__) {
        import("@sentry/react")
          .then((Sentry) => {
            Sentry.captureException(error, { extra: errorInfo });
          })
          .catch(() => {
            // ignore
          });
      }
    } catch {
      // ignore
    }
  }

  override render() {
    if (this.state.hasError) {
      return (
        <ServerErrorPage
          error={this.state.error}
          errorInfo={this.state.errorInfo}
          onReset={() => {
            this.setState({ hasError: false, error: null, errorInfo: null });
            window.location.href = "/";
          }}
        />
      );
    }

    return this.props.children;
  }
}
